import { useQuery } from '@tanstack/react-query';
import { moodleQueryKeys } from '../all-query-keys';
import { getMoodleConfigs } from '../../../services/MoodleService';

export const useGetMoodleConfigs = () => {
  const { data, isLoading } = useQuery({
    queryKey: moodleQueryKeys.getMoodleConfigs(),
    queryFn: getMoodleConfigs,
  });

  const configs = data?.data?.content || [];
  return { configs, loading: isLoading };
};
